/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from 'components/_new/Button';
import { Session } from 'types/Session';
import { SessionFile } from 'types/SessionFile';
import { Link } from 'components/_new/Link';
import { usePair } from 'contexts/pairContext';
import { UploadUserFilesDialog } from 'components/session/yourNotes/UploadUserFilesDialog';
import { useGlobal } from 'contexts/globalContext';
import { NoteList } from 'components/userPanel/userFiles/NoteList';

type YourNotesSubpageProps = {
	session: Session;
	files: SessionFile[];
	loading?: boolean;
	getUserFilesRefetch: () => void;
};

export const YourNotesSubpage = ({ session, files, loading = false, getUserFilesRefetch }: YourNotesSubpageProps) => {
	const { t } = useTranslation();
	const { path: pairPath } = usePair();
	const { closedWindowsCounts } = useGlobal();

	const [openModal, setOpenModal] = useState(false);
	const [selectedUserfile, setSelectedUserfile] = useState<SessionFile | undefined>(undefined);

	useEffect(() => {
		if ((closedWindowsCounts.ADD_SESSION_NOTE || 0) > 0) {
			getUserFilesRefetch();
		}
	}, [closedWindowsCounts, getUserFilesRefetch]);

	return (
		<>
			<UploadUserFilesDialog
				selectedUserfile={selectedUserfile}
				setSelectedUserfile={setSelectedUserfile}
				session={session}
				onFinish={() => {
					getUserFilesRefetch();
				}}
				onHide={() => {
					setOpenModal(false);
					getUserFilesRefetch();
				}}
				visible={openModal}
				withAddNewButton
			/>
			<div className="flex flex-column gap-2">
				<div className="flex flex-row gap-4 align-items-center justify-content-between">
					<h2 className="my-5">{t('userPanel.sessionsNew.yourNotes.heading')}</h2>
					<Button
						icon="plus"
						label={t('userPanel.sessionsNew.yourNotes.addNew')}
						variant="primary-text"
						onClick={() => {
							setSelectedUserfile(undefined);
							setOpenModal(true);
						}}
					/>
				</div>
				<p className="mt-2 mb-6">
					<Trans
						t={t}
						i18nKey="userPanel.userFiles.info"
						components={[<Link to={{ pathname: `${pairPath}/userfiles` }} />]}
					/>
				</p>
				<NoteList
					items={files}
					isLoading={loading}
					onUpdate={getUserFilesRefetch}
					dividedList
					defaultOpenInPreview
					currentSession={session}
				/>
			</div>
		</>
	);
};
